<template>
  <div class="palace-hall" @click="fullScreen($event)">
    <section class="palace-drawer" v-if="!reveal.handleStatus" @mouseenter="reveal.handleStatus=true">
      <div class="drawer-box">
        <div class="drawer-icon">
          <div class="icon-item"><img src="../../assets/images/hall/palace/focus-on-icon.png" /></div>
          <div class="icon-item"><img src="../../assets/images/hall/palace/bullet-screen-icon.png" /></div>
          <div class="icon-item"><img src="../../assets/images/hall/palace/comments-icon.png" /></div>
          <div class="icon-item"><img src="../../assets/images/hall/palace/desk-icon.png" /></div>
          <div class="icon-item"><img src="../../assets/images/hall/palace/pavilion-set-icon.png" /></div>
        </div>
      </div>
    </section>
    <section v-if="!reveal.columnStatus" class="palace-drawer-rig" @mouseenter="reveal.columnStatus=true">
      <div class="drawer-box">
        <div class="drawer-icon">
          <div class="icon-item"><img src="../../assets/images/hall/palace/life-is-introduced-icon.png" /></div>
          <div class="icon-item"><img src="../../assets/images/hall/palace/emblem-icon.png" /></div>
          <div class="icon-item"><img src="../../assets/images/hall/palace/biography-icon.png" /></div>
          <div class="icon-item"><img src="../../assets/images/hall/palace/eulogy-icon.png" /></div>
          <div class="icon-item"><img src="../../assets/images/hall/palace/smile-voice-icon.png" /></div>
          <div class="icon-item"><img src="../../assets/images/hall/palace/visit-record-icon.png" /></div>
          <div class="icon-item"><img src="../../assets/images/hall/palace/friends-circle-icon.png" /></div>
        </div>
      </div>
    </section>
    <div v-if="reveal.handleStatus" class="out-drawer animate__animated animate__slideInLeft"  @mouseleave="reveal.handleStatus=false">
      <div class="out-drawer-box">
        <div class="box-icon">
          <section class="common">
            <img src="../../assets/images/hall/palace/focus-on-icon.png" />
            <span>关注</span>
          </section>
          <section class="common">
            <img src="../../assets/images/hall/palace/bullet-screen-icon.png" />
            <span>弹幕</span>
          </section>
          <section class="common">
            <img src="../../assets/images/hall/palace/comments-icon.png" />
            <span>评论</span>
          </section>
          <section class="common">
            <img src="../../assets/images/hall/palace/desk-icon.png" />
            <span>桌子</span>
          </section>
          <section class="common">
            <img src="../../assets/images/hall/palace/pavilion-set-icon.png" />
            <span>馆设置</span>
          </section>
        </div>
      </div>
    </div>
    <div v-if="reveal.columnStatus" class="out-drawer-rig animate__animated animate__slideInRight" @mouseleave="reveal.columnStatus=false">
      <div class="drawer-rig-box">
        <div class="rig-box-icon">
          <section class="common">
            <img src="../../assets/images/hall/palace/life-is-introduced-icon.png" />
            <span>生平介绍</span>
          </section>
          <section class="common">
            <img src="../../assets/images/hall/palace/emblem-icon.png" />
            <span>荣誉</span>
          </section>
          <section class="common">
            <img src="../../assets/images/hall/palace/biography-icon.png" />
            <span>传记</span>
          </section>
          <section class="common">
            <img src="../../assets/images/hall/palace/eulogy-icon.png" />
            <span>悼文</span>
          </section>
          <section class="common">
            <img src="../../assets/images/hall/palace/smile-voice-icon.png" />
            <span>音容笑貌</span>
          </section>
          <section class="common">
            <img src="../../assets/images/hall/palace/visit-record-icon.png" />
            <span>祭拜记录</span>
          </section>
          <section class="common">
            <img src="../../assets/images/hall/palace/friends-circle-icon.png" />
            <span>亲友圈</span>
          </section>
        </div>
      </div>
    </div>

    <!--祭拜桌子-->
    <div class="palace-desk"></div>
    <!--祭拜留言-->
    <div class="send-dm">
      <section class="send-conten-box"><input type="text" v-model="sendContent" maxlength="50" @focus="selectInput" placeholder="祭祀留言.."></section>
      <section class="send-content-btn cursor" :style="[inputStyle]">发送</section>
    </div>
    <div class="send-list">
      <div data-v-352e85e1="" class="dm"><div data-v-352e85e1="" class="dm-user-box"><img data-v-352e85e1="" src="https://file.101el.com/api/Common/FileManage/Fetch?openId=c5835edba7fd4563877bf9305ed8a688&amp;width=40&amp;height=40" alt="" class="dm-user-img"></div> <div data-v-352e85e1="" class="dm-content"><span data-v-352e85e1="" class="dm-name-content"><span data-v-352e85e1="">2额2341</span><span data-v-352e85e1="">:送了爱心</span></span> <div data-v-352e85e1="" class="el-image dm-gift-img"><img src="https://file.101el.com/api/Common/FileManage/Fetch?openId=93772190b00041febdf3a74609a14a06" class="el-image__inner" style="object-fit: contain;"><!----></div> <!----></div></div><div data-v-352e85e1="" class="dm"><div data-v-352e85e1="" class="dm-user-box"><img data-v-352e85e1="" src="https://file.101el.com/api/Common/FileManage/Fetch?openId=94f79bd279414f8a9ce28f12b852c2e3&amp;width=40&amp;height=40" alt="" class="dm-user-img"></div> <div data-v-352e85e1="" class="dm-content"><span data-v-352e85e1="" class="dm-name-content"><span data-v-352e85e1="">用户180****1426</span><span data-v-352e85e1="">:送了爱心</span></span> <div data-v-352e85e1="" class="el-image dm-gift-img"><img src="https://file.101el.com/api/Common/FileManage/Fetch?openId=93772190b00041febdf3a74609a14a06" class="el-image__inner" style="object-fit: contain;"><!----></div> <!----></div></div><div data-v-352e85e1="" class="dm"><div data-v-352e85e1="" class="dm-user-box"><img data-v-352e85e1="" src="https://file.101el.com/api/Common/FileManage/Fetch?openId=94f79bd279414f8a9ce28f12b852c2e3&amp;width=40&amp;height=40" alt="" class="dm-user-img"></div> <div data-v-352e85e1="" class="dm-content"><span data-v-352e85e1="" class="dm-name-content"><span data-v-352e85e1="">用户180****1426</span><span data-v-352e85e1="">:送了爱心</span></span> <div data-v-352e85e1="" class="el-image dm-gift-img"><img src="https://file.101el.com/api/Common/FileManage/Fetch?openId=93772190b00041febdf3a74609a14a06" class="el-image__inner" style="object-fit: contain;"><!----></div> <!----></div></div><div data-v-352e85e1="" class="dm"><div data-v-352e85e1="" class="dm-user-box"><img data-v-352e85e1="" src="https://file.101el.com/api/Common/FileManage/Fetch?openId=94f79bd279414f8a9ce28f12b852c2e3&amp;width=40&amp;height=40" alt="" class="dm-user-img"></div> <div data-v-352e85e1="" class="dm-content"><span data-v-352e85e1="" class="dm-name-content"><span data-v-352e85e1="">用户180****1426</span><span data-v-352e85e1="">:送了熏香炉</span></span> <div data-v-352e85e1="" class="el-image dm-gift-img"><img src="https://file.101el.com/api/Common/FileManage/Fetch?openId=f050bf04d46242fea64f43e46e4f4e9c" class="el-image__inner" style="object-fit: contain;"><!----></div> <!----></div></div><div data-v-352e85e1="" class="dm"><div data-v-352e85e1="" class="dm-user-box"><img data-v-352e85e1="" src="https://file.101el.com/api/Common/FileManage/Fetch?openId=94f79bd279414f8a9ce28f12b852c2e3&amp;width=40&amp;height=40" alt="" class="dm-user-img"></div> <div data-v-352e85e1="" class="dm-content"><span data-v-352e85e1="" class="dm-name-content"><span data-v-352e85e1="">用户180****1426</span><span data-v-352e85e1="">:送了跑车</span></span> <div data-v-352e85e1="" class="el-image dm-gift-img"><img src="https://file.101el.com/api/Common/FileManage/Fetch?openId=c395582708da4f3e883523e106380b5f" class="el-image__inner" style="object-fit: contain;"><!----></div> <!----></div></div><div data-v-352e85e1="" class="dm"><div data-v-352e85e1="" class="dm-user-box"><img data-v-352e85e1="" src="https://file.101el.com/api/Common/FileManage/Fetch?openId=94f79bd279414f8a9ce28f12b852c2e3&amp;width=40&amp;height=40" alt="" class="dm-user-img"></div> <div data-v-352e85e1="" class="dm-content"><span data-v-352e85e1="" class="dm-name-content"><span data-v-352e85e1="">用户180****1426</span><span data-v-352e85e1="">:送了别墅</span></span> <div data-v-352e85e1="" class="el-image dm-gift-img"><img src="https://file.101el.com/api/Common/FileManage/Fetch?openId=fd7b44f1fe354f68b6fbfb2f4249826e" class="el-image__inner" style="object-fit: contain;"><!----></div> <!----></div></div><div data-v-352e85e1="" class="dm"><div data-v-352e85e1="" class="dm-user-box"><img data-v-352e85e1="" src="https://file.101el.com/api/Common/FileManage/Fetch?openId=94f79bd279414f8a9ce28f12b852c2e3&amp;width=40&amp;height=40" alt="" class="dm-user-img"></div> <div data-v-352e85e1="" class="dm-content"><span data-v-352e85e1="" class="dm-name-content"><span data-v-352e85e1="">用户180****1426</span><span data-v-352e85e1="">:送了香烟</span></span> <div data-v-352e85e1="" class="el-image dm-gift-img"><img src="https://file.101el.com/api/Common/FileManage/Fetch?openId=624c1ccdc2a1456aa113c55ec8aa9e5a" class="el-image__inner" style="object-fit: contain;"><!----></div> <!----></div></div><div data-v-352e85e1="" class="dm"><div data-v-352e85e1="" class="dm-user-box"><img data-v-352e85e1="" src="https://file.101el.com/api/Common/FileManage/Fetch?openId=94f79bd279414f8a9ce28f12b852c2e3&amp;width=40&amp;height=40" alt="" class="dm-user-img"></div> <div data-v-352e85e1="" class="dm-content"><span data-v-352e85e1="" class="dm-name-content"><span data-v-352e85e1="">用户180****1426</span><span data-v-352e85e1="">:我来了</span></span> <!----> <!----></div></div><div data-v-352e85e1="" class="dm"><div data-v-352e85e1="" class="dm-user-box"><img data-v-352e85e1="" src="https://file.101el.com/api/Common/FileManage/Fetch?openId=94f79bd279414f8a9ce28f12b852c2e3&amp;width=40&amp;height=40" alt="" class="dm-user-img"></div> <div data-v-352e85e1="" class="dm-content"><span data-v-352e85e1="" class="dm-name-content"><span data-v-352e85e1="">用户180****1426</span><span data-v-352e85e1="">:我来了</span></span> <!----> <!----></div></div><div data-v-352e85e1="" class="dm"><div data-v-352e85e1="" class="dm-user-box"><img data-v-352e85e1="" src="https://file.101el.com/api/Common/FileManage/Fetch?openId=94f79bd279414f8a9ce28f12b852c2e3&amp;width=40&amp;height=40" alt="" class="dm-user-img"></div> <div data-v-352e85e1="" class="dm-content"><span data-v-352e85e1="" class="dm-name-content"><span data-v-352e85e1="">用户180****1426</span><span data-v-352e85e1="">:送了螃蟹</span></span> <div data-v-352e85e1="" class="el-image dm-gift-img"><img src="https://file.101el.com/api/Common/FileManage/Fetch?openId=c59426b4844b473d8e526fbc0b61e722" class="el-image__inner" style="object-fit: contain;"><!----></div> <!----></div></div><div data-v-352e85e1="" class="dm"><div data-v-352e85e1="" class="dm-user-box"><img data-v-352e85e1="" src="https://file.101el.com/api/Common/FileManage/Fetch?openId=94f79bd279414f8a9ce28f12b852c2e3&amp;width=40&amp;height=40" alt="" class="dm-user-img"></div> <div data-v-352e85e1="" class="dm-content"><span data-v-352e85e1="" class="dm-name-content"><span data-v-352e85e1="">用户180****1426</span><span data-v-352e85e1="">:送了文房四宝</span></span> <div data-v-352e85e1="" class="el-image dm-gift-img"><img src="https://file.101el.com/api/Common/FileManage/Fetch?openId=a48fcc75bb254da2810f48dfe3c9bd04" class="el-image__inner" style="object-fit: contain;"><!----></div> <!----></div></div><div data-v-352e85e1="" class="dm"><div data-v-352e85e1="" class="dm-user-box"><img data-v-352e85e1="" src="https://file.101el.com/api/Common/FileManage/Fetch?openId=94f79bd279414f8a9ce28f12b852c2e3&amp;width=40&amp;height=40" alt="" class="dm-user-img"></div> <div data-v-352e85e1="" class="dm-content"><span data-v-352e85e1="" class="dm-name-content"><span data-v-352e85e1="">用户180****1426</span><span data-v-352e85e1="">:送了象棋</span></span> <div data-v-352e85e1="" class="el-image dm-gift-img"><img src="https://file.101el.com/api/Common/FileManage/Fetch?openId=4553469a39ec4db88248ecde221d8bcd" class="el-image__inner" style="object-fit: contain;"><!----></div> <!----></div></div><div data-v-352e85e1="" class="dm"><div data-v-352e85e1="" class="dm-user-box"><img data-v-352e85e1="" src="https://file.101el.com/api/Common/FileManage/Fetch?openId=94f79bd279414f8a9ce28f12b852c2e3&amp;width=40&amp;height=40" alt="" class="dm-user-img"></div> <div data-v-352e85e1="" class="dm-content"><span data-v-352e85e1="" class="dm-name-content"><span data-v-352e85e1="">用户180****1426</span><span data-v-352e85e1="">:我来了啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊</span></span> <!----> <!----></div></div>
    </div>

    <!--礼物赠送-->
    <div class="palace-gift" @click="reveal.giftTableVisible=!reveal.giftTableVisible">
      <img class="cursor" src="../../assets/images/hall/palace/palace-gift-btn.png" />
    </div>
    <div v-show="reveal.giftTableVisible"  class="gift-reveal animate__animated animate__rotateInUpRight">
      <div class="kind-contaier">
        <div class="kind-box">
          <div id="gift-kind" class="gift-kind">
            <button>蜡烛</button>
            <button>鲜花</button>
            <button>祭食</button>
            <button>点香</button>
            <button>灯</button>
            <button>献元宝</button>
            <button>鞭炮</button>
          </div>
        </div>
        <div @click="kindIncrease(true)" class="kind-button-prev"></div>
        <div @click="kindIncrease(false)" class="kind-button-next"></div>
      </div>
      <div class="gift-list">
        <div class="list-box">
          <div class="box-group"  id="gift-card">
            <div class="gift-card"
                 v-for="index in gift.len"
                 @click="selectedGift(index)"
                 :class="[index === gift.active ? 'gift-active' : '']"
            >
              <div class="card-icon">
                <img src="../../assets/images/hall/palace/gift-list-icon.png" />
              </div>
            </div>
          </div>
          <div @click="giftIncrease(true)" class="gift-button-prev"></div>
          <div @click="giftIncrease(false)" class="gift-button-next"></div>
        </div>
      </div>
      <div class="gift-send">
        <button type="button">发送</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'palace-hall',
    data() {
      return {
        reveal: {
          handleStatus: false, //左侧鼠标经过状态
          columnStatus: false, //右侧鼠标经过状态
          giftTableVisible: true
        },
        sendContent: '',
        kind: {
          elem: '',
          translate: 0,
          count: 0
        },
        gift: {
          elem: '',
          translate: 0,
          count: 0,
          len: 14,
          active: ''
        }
      }
    },
    computed: {
      inputStyle() {
        let style = {};
        if (this.sendContent) {
          style.backgroundColor = '#7AAADA';
        }
        return style
      }
    },
    mounted() {
      this.kind.elem = document.getElementById('gift-kind')
      this.gift.elem = document.getElementById('gift-card')
      if (this.kind.elem && this.gift.elem) {
        this.reveal.giftTableVisible = false;
      }
    },
    methods: {
      selectInput() {
        console.log('input选中事件')
      },
      selectedGift(index) {
        const gift = this.gift;
        gift.active = index;
      },
      fullScreen(event) {
        if (!event.target.closest('.gift-reveal, .palace-gift')) {
          this.reveal.giftTableVisible = false
        }
      },
      kindIncrease(b) {
        let moveLef = () => {
          if (this.kind.count === 0) {
            return
          }
          this.kind.elem.style = `transform:translateX(${this.kind.translate + 126}px)`
          this.kind.translate = this.kind.translate + 126
          this.kind.count--
        };
        let moveRig = () => {
          if (this.kind.count >= 6) {
            return
          }
          this.kind.elem.style=`transform:translateX(${this.kind.translate - 126}px)`
          this.kind.translate = this.kind.translate - 126
          this.kind.count++
        };
        b ? moveLef() : moveRig()
      },
      giftIncrease(b) {
        let moveLef = () => {
          if (this.gift.count === 0) {
            return
          }
          this.gift.elem.style = `transform:translateX(${this.gift.translate + 120}px)`
          this.gift.translate = this.gift.translate + 120
          this.gift.count--
        };
        let moveRig = () => {
          if (this.gift.count >= this.gift.len - 2) {
            return
          }
          this.gift.elem.style=`transform:translateX(${this.gift.translate - 120}px)`
          this.gift.translate = this.gift.translate - 120
          this.gift.count++
        };
        b ? moveLef() : moveRig()
      }
    }
  }
</script>

<style lang="scss" scoped>
.palace-hall {
  width: 100%;
  height: 100vh;
  background: url("../../assets/images/hall/palace/palace-bg.png") no-repeat center;
  background-size: cover;
  position: relative;
  z-index: 22;
  overflow: hidden;
  .gift-reveal {
    position: fixed;
    z-index: 999;
    width: 600px;
    height: 453px;
    border-radius: 20px;
    background: #ffffff;
    top: 134px;
    left: -220px;
    right: 0;
    margin: 0 auto;
    background: url("../../assets/images/hall/palace/gift-box.png")no-repeat center;
    background-size: cover;
    padding: 36px 20px;
    .gift-send {
      @include w-flex;
      @include align-items;
      @include justify-content;
      padding: 20px 0;
      button {
        width: 150px;
        height: 40px;
        background: linear-gradient(84deg, #7AAADA, #407EB2);
        border-radius: 20px;
        border: none;
        font-size: 18px;
        color: #FFFFFF;
      }
    }
    .gift-list {
      position: relative;
      .gift-button-prev {
        position: absolute;
        top: 70px;
        left: 2px;
        width: 30px;
        cursor: pointer;
        height: 30px;
        background: url('../../assets/images/hall/wm_button_icon.png') no-repeat;
        background-position: 0 0;
        background-size: 100%;
        &:hover {
           background-position: 0 -31px;background-size: 100%
         }
      }
      .gift-button-next {
        position: absolute;
        right: 2px;
        top: 70px;
        width: 30px;
        height: 30px;
        cursor: pointer;
        background: url('../../assets/images/hall/wm_button_icon.png') no-repeat;
        background-position: 0 -62px;
        background-size: 100%;
        &:hover {background-position: 0 -92px;background-size: 100%}
      }
      .list-box {
        overflow: hidden;
        margin: 38px 40px;
        .box-group {
          @include w-flex;
          .gift-card {
            cursor: pointer;
            padding: 44px 20px;
            .card-icon {
              margin: 0 auto;
              width: 80px;
              height: 80px;
            }
          }
          .gift-active {
            background: rgba(12, 12, 12, 0.5);
          }
        }
      }
    }
    .kind-contaier {
      position: relative;
      .kind-button-prev {
        position: absolute;
        top: 8px;
        left: -10px;
        width: 30px;
        cursor: pointer;
        height: 30px;
        background: url('../../assets/images/hall/wm_button_icon.png') no-repeat;
        background-position: 0 0;
        background-size: 100%;
        &:hover {
           background-position: 0 -31px;background-size: 100%
         }
      }
      .kind-button-next {
        position: absolute;
        right: -8px;
        top: 8px;
        width: 30px;
        height: 30px;
        cursor: pointer;
        background: url('../../assets/images/hall/wm_button_icon.png') no-repeat;
        background-position: 0 -62px;
        background-size: 100%;
        &:hover {background-position: 0 -92px;background-size: 100%}
      }
      .kind-box {
        overflow: hidden;
        margin: 20px 30px;
        .gift-kind {
          @include w-flex;
          button {
            min-width: 120px;
            height: 45px;
            background: url("../../assets/images/hall/palace/gift-kind-bottom.png") no-repeat center;
            background-size: cover;
            border: none;
            font-size: 18px;
            font-weight: bold;
            color: #FFFFFF;
            margin-right: 6px;
          }
        }
      }
    }
  }
  .palace-gift {
    position: fixed;
    right: 0;
    bottom: 32px;
    z-index: 999;
  }
  .palace-desk {
    width: 889px;
    height: 201px;
    background: url("../../assets/images/hall/palace/palace-desk.png") no-repeat center;
    background-size: cover;
    position: fixed;
    left: -220px;
    right: 0;
    bottom: 124px;
    z-index: 22;
    margin: 0 auto;
  }
  .send-list {
    width: 320px;
    height: 290px;
    padding: 0;
    position: fixed;
    right: 135px;
    top: 48px;
    overflow: hidden;
    overflow-y: scroll;
    z-index: 99;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    border-top: 40px solid rgba(255, 255, 255, 0);
    .dm {
      background: -webkit-gradient(linear, left bottom, left top, from(rgba(0, 0, 0, 0.3)), to(rgba(0, 0, 0, 0)));
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0));
      margin-top: 24px;
      border-radius: 20px;
      .dm-user-box {
        float: left;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: flex-start;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        .dm-user-img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          vertical-align: middle;
        }
      }
      .dm-content {
        height: auto;
        min-height: 40px;
        line-height: 40px;
        vertical-align: middle;
        .dm-name-content {
          display: inline-block;
          vertical-align: middle;
          max-width: 256px;
          font-size: 15px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          margin-left: 14px;
          white-space: normal;
          word-break: break-all;
          span {
            vertical-align: middle;
          }:first-child{display: inline-block;max-width: 100px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
        }
        .el-image {
          width: 40px;
          height: 40px;
          margin-left: 15px;
          vertical-align: middle;
        }
        .dm-gift-img {
          position: relative;
          display: inline-block;
          overflow: hidden;
        }
      }
    }
    &::-webkit-scrollbar {
       display: none; /* Chrome Safari */
     }
  }
  .send-dm {
    width: 800px;
    height: 50px;
    background: #1B1B1B;
    opacity: 0.8;
    border-radius: 25px;
    position: fixed;
    left: -220px;
    right: 0;
    bottom: 32px;
    margin: 0 auto;
    .send-conten-box {
      display: inline-block;
      vertical-align: middle;
      width: 90%;
      height: 100%;
      background: rgba(0, 0, 0, 0.4);
      border-radius: 25px 0px 0px 25px;
      input {
        width: 90%;
        height: 30px;
        outline: 0;
        border: none;
        background: none;
        color: white;
        margin: 9px 9px 6px 15px;
        font-size: 16px;
      }
    }
    .send-content-btn {
      display: inline-block;
      vertical-align: middle;
      width: 80px;
      height: 50px;
      background: rgba(0, 0, 0, 0.6);
      border-radius: 0px 25px 25px 0px;
      font-size: 14px;
      color: rgba(255, 255, 255, 1);
      line-height: 50px;
      text-align: center;
    }
  }
  .out-drawer-rig {
    width: 200px;
    height: 100%;
    background: #1B1B1B;
    opacity: 0.8;
    position: fixed;
    right: 0;
    top: 82px;
    z-index: 9999;
    .drawer-rig-box {
      width: 100%;
      height: 100%;
      .rig-box-icon {
        margin-top: 12px;
        width: 100%;
        .common {
          width: 100%;
          height: 64px;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-align: center;
          -ms-flex-align: center;
          cursor: pointer;
          align-items: center;
          padding-left: 44px;
          span {
            font-size: 18px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            margin-left: 8px;
          }
          img {
            width: 35px;
            height: 35px;
          }
          &:hover {
             background: linear-gradient(90deg, rgba(121, 170, 217, 0) 0%, #407DB2 100%);
           }
        }
      }
    }
  }
  .out-drawer {
    width: 200px;
    height: 100%;
    background: #1B1B1B;
    opacity: 0.8;
    position: fixed;
    left: 0;
    top: 82px;
    z-index: 9999;
    .out-drawer-box {
      width: 100%;
      height: 100%;
      @include w-flex;
      @include align-items;
      .box-icon {
        width: 100%;
        .common {
          width: 100%;
          height: 64px;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-align: center;
          -ms-flex-align: center;
          cursor: pointer;
          align-items: center;
          padding-left: 44px;
          span {
            font-size: 18px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            margin-left: 8px;
          }
          img {
            width: 35px;
            height: 35px;
          }
          &:hover {
             background: linear-gradient(90deg, rgba(121, 170, 217, 0) 0%, #407DB2 100%);
           }
        }
      }
    }
  }
  .palace-drawer-rig {
    width: 80px;
    height: 100%;
    background: #1B1B1B;
    opacity: 0.8;
    position: fixed;
    right: 0;
    top: 82px;
    z-index: 887;
    .drawer-box {
      width: 100%;
      height: 100%;
      .drawer-icon {
        margin-top: 28px;
        width: 100%;
        .icon-item {
          margin-bottom: 30px;
          width: 100%;
          img {
            width: 35px;
            height: 35px;
            display: block;
            margin: 0 auto;
          }
        }
      }
    }
  }
  .palace-drawer {
    width: 80px;
    height: 100%;
    background: #1B1B1B;
    opacity: 0.8;
    position: fixed;
    left: 0;
    top: 82px;
    z-index: 887;
    .drawer-box {
      width: 100%;
      height: 100%;
      @include w-flex;
      @include align-items;
      .drawer-icon {
        width: 100%;
        .icon-item {
          margin-bottom: 30px;
          width: 100%;
          img {
            width: 35px;
            height: 35px;
            display: block;
            margin: 0 auto;
          }
        }
      }
    }
  }
}
</style>
